module.exports = __webpack_public_path__ + "static/media/ggPlay.a29f469c.png";